import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { updateProductDetails } from '../../../../../api/Api';
import { getFromLocalStorage } from '../../../../../utils/common-utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import "./common.css";

const animatedComponents = makeAnimated();

const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  
  // Split the date string and take only the date part
  const [datePart] = dateString.split(' ');
  const [year, month, day] = datePart.split('-');
  
  // Create date string in YYYY-MM-DD format
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const EditProductDetails = ({ editData, onUpdate }) => {
  const [formData, setFormData] = useState({
    id: '',
    userId: '',
    channel: '',
    unsubChannel: '',
    description: '',
    language: '',
    productName: '',
    operatorServiceId: '',    
    category: '',
    packageValidityForm: '',
    packageValidityTo: '',
    alphaNumeric: ''
  });

  const [loading, setLoading] = useState(false);

  const channelOptions = [
    { value: 'SMS', label: 'SMS' },
    { value: 'WEB', label: 'WEB' },
    { value: 'APP', label: 'APP' },
    { value: 'USSD', label: 'USSD' },
    { value: 'CCI', label: 'CCI' }
  ];

  const languageOptions = ['English', 'Hindi', 'Arabic'];
  const categoryOptions = [
    'Entertainment',
    'Education',
    'Gaming',
    'Health',
    'Lifestyle',
    'News',
    'Sports',
    'Rental Process & Customer'
  ];

  // Custom styles for react-select
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 38,
      background: '#fff',
      borderColor: '#ced4da',
      '&:hover': {
        borderColor: '#80bdff'
      }
    }),
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      backgroundColor: isSelected ? '#007bff' : isFocused ? '#f8f9fa' : null,
      color: isSelected ? 'white' : '#333',
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      ':before': {
        content: isSelected ? '"✓"' : '""',
        marginRight: '8px',
        width: '16px'
      }
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#e9ecef',
      padding: '2px'
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#495057'
    }),
    multiValueRemove: (base) => ({
      ...base,
      ':hover': {
        backgroundColor: '#dc3545',
        color: 'white'
      }
    })
  };

  // Format channels string to array of objects for react-select
  const formatChannelsToOptions = (channelsString) => {
    if (!channelsString) return [];
    const channelArray = channelsString.split(',');
    return channelArray.map(channel => ({
      value: channel.trim(),
      label: channel.trim()
    }));
  };

  // Handle subscription channel change
  const handleSubscriptionChannelChange = (selectedOptions) => {
    const channels = selectedOptions ? selectedOptions.map(option => option.value).join(',') : '';
    setFormData(prev => ({
      ...prev,
      channel: channels
    }));
  };

  // Handle unsubscription channel change
  const handleUnsubscriptionChannelChange = (selectedOptions) => {
    const channels = selectedOptions ? selectedOptions.map(option => option.value).join(',') : '';
    setFormData(prev => ({
      ...prev,
      unsubChannel: channels
    }));
  };

  useEffect(() => {
    if (editData) {
      // Format dates to YYYY-MM-DD for HTML date input
      console.log("dateform",editData?.packageValidityForm,editData?.packageValidityTo);
      setFormData({
        id: editData.id || '',
        userId: getFromLocalStorage("userData")?.id || '',
        channel: editData.channel || '',
        unsubChannel: editData.unsubChannel || '',
        description: editData.description || '',
        language: editData.language || '',
        productName: editData.productName || '',
        operatorServiceId: editData.operatorServiceId || '',
        category: editData.category || '',
        packageValidityForm: editData.packageValidityForm,
        packageValidityTo: editData.packageValidityTo,
        alphaNumeric: editData.alphaNumeric || ''
      });
    }
  }, [editData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'packageValidityForm' || name === 'packageValidityTo') {
      // Keep the date in YYYY-MM-DD HH:mm:ss format
      const formattedDate = value ? `${value} 00:00:00` : '';
      setFormData(prev => ({
        ...prev,
        [name]: formattedDate
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
console.log("formDataxddd",formData?.packageValidityForm,formData?.packageValidityTo);
  const showLoadingAlert = () => {
    Swal.fire({
      title: 'Updating Product Details',
      html: 'Please wait...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate dates
    if (new Date(formData.packageValidityTo) <= new Date(formData.packageValidityForm)) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Validity To date must be after Validity From date'
      });
      return;
    }

    // Validate channel
    if (!formData.channel) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please select at least one channel'
      });
      return;
    }

    const result = await Swal.fire({
      title: 'Confirm Update',
      text: 'Are you sure you want to update the product details?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!'
    });

    if (result.isConfirmed) {
      try {
        showLoadingAlert();
        setLoading(true);

        const response = await updateProductDetails({
          ...formData,
          packageValidityForm: formData.packageValidityForm + ' 00:00:00',
          packageValidityTo: formData.packageValidityTo + ' 23:59:59'
        });

        // Check for status in statusDescription
        if (response?.statusDescription?.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: response.statusDescription.description,
            timer: 2000,
            showConfirmButton: false
          }).then(() => {
            // Update the parent component with the appStoreProduct data
            onUpdate && onUpdate(response.appStoreProduct);
          });
        } else {
          throw new Error(response?.statusDescription?.description || 'Failed to update product details');
        }
      } catch (error) {
        console.error('Update error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: error.message || 'An error occurred while updating product details',
          confirmButtonColor: '#3085d6'
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="tab-content-section">
      <form onSubmit={handleSubmit} className="product-details-form">
        <div className="row g-3">
          {/* Product Name */}
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Product Name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Product Name"
                name="productName"
                value={formData.productName}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          {/* Language */}
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Language<span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                name="language"
                value={formData.language}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Language</option>
                {languageOptions.map(lang => (
                  <option key={lang} value={lang}>{lang}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Package Validity From */}
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Package validity From<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                name="packageValidityForm"
                value={formatDateForInput(formData.packageValidityForm)}
                onChange={handleInputChange}
                // min={formatDateForInput(new Date().toISOString())}
                required
              />
            </div>
          </div>

          {/* Package Validity To */}
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Package validity To<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                name="packageValidityTo"
                value={formatDateForInput(formData.packageValidityTo)}
                onChange={handleInputChange}
                min={formData.packageValidityForm ? formatDateForInput(formData.packageValidityForm) : formatDateForInput(new Date().toISOString())}
                disabled={!formData.packageValidityForm}
                required
              />
              {formData.packageValidityForm && !formData.packageValidityTo && (
                <small className="text-muted">
                  Please select an end date after {new Date(formData.packageValidityForm).toLocaleDateString()}
                </small>
              )}
            </div>
          </div>

          {/* Category */}
          <div className="col-md-6">
            <div className="form-group position-relative">
              <label>
                Category<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Category"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                required
                list="categoryOptions"
              />
              <datalist id="categoryOptions" className='position-absolute'>
                {categoryOptions.map(cat => (
                  <option key={cat} value={cat} />
                ))}
              </datalist>
            </div>
          </div>

        
         

          {/* Subscription Channel */}
          <div className="col-md-6 sub_chan">
            <div className="form-group">
              <label>
                Subscription Channel<span className="text-danger">*</span>
              </label>
              <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                isMulti
                options={channelOptions}
                styles={customStyles}
                value={formatChannelsToOptions(formData.channel)}
                onChange={handleSubscriptionChannelChange}
                placeholder="Select Channel(s)"
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          </div>

          {/* Unsubscription Channel */}
          <div className="col-md-6 sub_chan">
            <div className="form-group">
              <label>
                Unsubscription Channel<span className="text-danger">*</span>
              </label>
              <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                isMulti
                options={channelOptions}
                styles={customStyles}
                value={formatChannelsToOptions(formData.unsubChannel)}
                onChange={handleUnsubscriptionChannelChange}
                placeholder="Select Channel(s)"
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          </div>


          {/* Operator Service ID */}
          <div className="col-md-6">
            <div className="form-group">
              <label>Operator Service ID</label>
              <input
                type="text" maxLength={10}
                className="form-control"
                name="operatorServiceId"
                
                value={formData.operatorServiceId}
                onChange={handleInputChange}
                placeholder="Enter Operator Service ID"
              />
            </div>  
          </div>

<div className="col-md-4">
    <div className="form-group">
    <label>Alpha Numeric</label>
    <input
      type="text"
      className="form-control"
      name="alphaNumeric"
      value={formData.alphaNumeric}
      onChange={handleInputChange}
      placeholder="Enter Alpha Numeric"
      />
      </div>
      </div>


          {/* Product Description */}
          <div className="col-8">
            <div className="form-group">
              <label>Product Description</label>
              <textarea
                className="form-control"
                placeholder="Enter Product Description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="3"
              />
            </div>
          </div>
        </div>

        <div className="form-actions mt-4 buttons_divs d-flex justify-content-end">
          <button 
            type="submit" 
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Product Details'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProductDetails;

